// import HtmlPages from "@/view/HtmlPages/Page";
import store from "@/store";
const components = {
    OriginLatency: () => import("@/view/dashboard/OriginLatency"),
    OriginPolicy: () => import("@/view/OriginPolicy/Page"),
    HtmlPages: () => import("@/view/HtmlPages/Page"),
    Scrolls: () => import("@/view/Scrolls/Page"),
    OWASP: () => import("@/view/OWASP/Page"),
    AlertRules: () => import("@/view/AlertRules/Page"),
    NotificationChannels: () => import("@/view/NotificationChannels/Page"),
    RequireUpgrade: () => import("@/view/general/RequireUpgrade"),
};

const checkPlanFeature = (featureName) => {
    const { features } = store.getters;
    const { planSpec, currentPlan } = store.state.platformPlan;

    let result = {
        available: false,
        leastPlan: "Enterprise",
    };

    let leastPlanIndex = planSpec.findIndex((e) => e.features.includes(featureName));
    // plan 填寫錯誤 或是還沒從後台獲取回來
    if (leastPlanIndex == -1) return result;
    let leastPlanName = planSpec[leastPlanIndex].planName;

    let currentPlanIndex = planSpec.findIndex((e) => e.planName == currentPlan);

    if (currentPlanIndex >= leastPlanIndex) {
        result.available = true;
    } else {
        result.leastPlan = leastPlanName;
    }
    return result;
};

const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export default {
    functional: true,
    props: {
        componentName: { type: String, default: "" },
        isCheckPlanFeature: { type: Boolean, default: false },
        featureName: { type: String, default: "" },
    },
    render(h, ctx) {
        let { componentName, isCheckPlanFeature, featureName } = ctx.props;
        let renderComponentName = componentName;
        if (isCheckPlanFeature) {
            let checkResult = checkPlanFeature(featureName);
            if (!checkResult.available) {
                renderComponentName = "RequireUpgrade";
                ctx.data.props.leastPlan = capitalize(checkResult.leastPlan);
            }
        }
        return h(components[renderComponentName], ctx.data, ctx.children);
    },
};



// WEBPACK FOOTER //
// ./src/components/DynamicComponent.js